/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-08-23 11:23:50
 * @modify date 2021-08-23 11:23:50
 * @desc [算法]
 */
import CryptoJSBASE64 from 'crypto-js/enc-base64';
import CryptoJSUTF8 from 'crypto-js/enc-utf8';
import CryptoJSMD5 from 'crypto-js/md5';
import dayjs from 'dayjs';
import lodash from 'lodash';
const day = dayjs().format('YYYY-MM-DD');
export class CustomEncryption {
    static GUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            let r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    static uniqueId() {
        return CustomEncryption.MD5(CustomEncryption.GUID());
    }
    static MD5(params) {
        if (!lodash.isString(params)) {
            params = JSON.stringify(params);
        }
        return CryptoJSMD5(params).toString();
    }
    //BASE64加密
    static BASE64(params) {
        if (!lodash.isString(params)) {
            params = JSON.stringify(params);
        }
        const utf8Str = CryptoJSUTF8.parse(params);
        return CryptoJSBASE64.stringify(utf8Str);
    }
    //BASE64解密
    static DECBASE64(params) {
        //base64 解密
        const parsedWordArray = CryptoJSBASE64.parse(params);
        return parsedWordArray.toString(CryptoJSUTF8);
    }
}
